import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Target, Menu, X, Mail } from "lucide-react";

const NAV = [
  { label: "Home", to: "/" },
  { label: "Common Number", to: "/common-number" },
  { label: "Dream Number", to: "/dream-number" },
  { label: "Previous Result", to: "/previous-result" },
  { label: "Club Chart", to: "/club-chart" },
  { label: "Analysis", to: "/analysis" },
  { label: "Blog", to: "/blog" },
];

export function Header() {
  const [open, setOpen] = React.useState(false);
  const loc = useLocation();

  return (
    <header className="sticky top-0 z-50 bg-[#e8491d] text-white shadow-md">
      <div className="max-w-5xl mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2.5">
            <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center shadow">
              <Target className="w-7 h-7 text-[#e8491d]" strokeWidth={2.5} />
            </div>
            <div className="leading-tight">
              <div className="text-lg sm:text-xl font-black tracking-tight">Sunday Ground Teer</div>
            </div>
          </Link>
          <button
            className="md:hidden p-2 rounded-lg hover:bg-white/15"
            onClick={() => setOpen((v) => !v)}
            aria-label="menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
          <nav className="hidden md:flex items-center gap-1">
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                className={`px-3 py-2 rounded-lg text-sm font-semibold transition-colors ${
                  loc.pathname === n.to ? "bg-white text-[#e8491d]" : "hover:bg-white/15"
                }`}
              >
                {n.label}
              </Link>
            ))}
          </nav>
        </div>
      </div>
      {open && (
        <nav className="md:hidden bg-[#c53a12] px-4 pb-3 flex flex-col">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              onClick={() => setOpen(false)}
              className={`px-3 py-2.5 rounded-lg text-sm font-semibold ${
                loc.pathname === n.to ? "bg-white text-[#e8491d]" : "hover:bg-white/15"
              }`}
            >
              {n.label}
            </Link>
          ))}
        </nav>
      )}
    </header>
  );
}

export function Footer() {
  return (
    <footer className="bg-[#1f2733] text-gray-300 mt-10">
      <div className="max-w-5xl mx-auto px-4 py-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2.5">
            <div className="w-9 h-9 rounded-full bg-[#e8491d] flex items-center justify-center">
              <Target className="w-6 h-6 text-white" strokeWidth={2.5} />
            </div>
            <span className="font-black text-white text-lg">Sunday Ground Teer</span>
          </div>
          <a
            href="mailto:Shillongmorningteer4758@gmail.com"
            className="flex items-center gap-2 text-sm hover:text-white transition-colors"
          >
            <Mail className="w-4 h-4" /> Shillongmorningteer4758@gmail.com
          </a>
        </div>
        <div className="mt-6 pt-5 border-t border-white/10 text-center text-xs text-gray-400 leading-relaxed">
          <p className="mb-2">
            Disclaimer: This website is for information &amp; entertainment purposes only. Teer is a
            game of chance; please play responsibly.
          </p>
          © {new Date().getFullYear()} Sunday Ground Teer. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
}

export function PageShell({ title, subtitle, children }) {
  return (
    <div className="max-w-5xl mx-auto px-4 py-6">
      {title && (
        <div className="mb-5 text-center">
          <h1 className="text-2xl sm:text-3xl font-black text-[#1f2733]">{title}</h1>
          {subtitle && <p className="text-sm text-gray-500 mt-1">{subtitle}</p>}
          <div className="w-24 h-1 bg-[#e8491d] rounded-full mx-auto mt-3" />
        </div>
      )}
      {children}
    </div>
  );
}
